import { useContext } from 'react'
import Image from 'next/image'
import { ChatbotUIContext } from '@/context/context'
import { getAssistantPublicImageUrl } from '@/db/storage/assistant-images'
import logo from '@/public/logo.png'
import { Tables } from '@/supabase/types'
import { useTheme } from 'next-themes'

import { cn } from '@/lib/utils'
import { ChatbotUISVG } from '@/components/icons/chatbotui-svg'

export function AssistantIcon({
  assistant,
  size = 29,
  className = '',
  excludeSpecificLogos = false
}: {
  assistant: Tables<'assistants'> | null
  size?: number
  className?: string
  excludeSpecificLogos?: boolean
}) {
  const { theme } = useTheme()
  const image = assistant?.image_path
  const name = assistant?.name ?? 'Assistant'

  const excludedAssistants = ['perplexity', 'gpt4o', 'sonnet']
  const shouldShowDefaultIcon =
    excludeSpecificLogos && assistant && excludedAssistants.includes(assistant.name.toLowerCase())

  return (
    <div
      className={cn(
        `size-[${size}px] flex shrink-0 items-center justify-center overflow-hidden rounded`,
        className,
        image && !shouldShowDefaultIcon
      )}
    >
      {image && !shouldShowDefaultIcon ? (
        <Image
          src={getAssistantPublicImageUrl(assistant!.image_path)}
          alt={name}
          width={size}
          height={size}
          className={`max-w-[${size}px]`}
        />
      ) : (
        <Image className={cn('rounded-sm')} src={logo} alt="Losi" height={size} width={size} />
      )}
    </div>
  )
}
